import React from "react"

export const LoadingIndicator: React.FC = () => {
  return (
    <div className="flex items-center gap-0.5 h-5">
      {[0, 1, 2, 3, 4, 5, 6].map((i) => (
        <div
          key={i}
          className="w-0.5 bg-surface-2 rounded-full animate-pulse"
          style={{
            height: `${8 + Math.sin(i * 0.8) * 6}px`,
            animationDelay: `${i * 100}ms`,
            animationDuration: "800ms",
          }}
        />
      ))}
    </div>
  )
}
